import {Injectable, OnDestroy} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {GenericDataService} from "../../data/generic-data.service";
import {ModelID} from "../../_typing/generic-types";
import {SingleResponse} from "../../services/api/response-types";
import {GenericJob, Job} from "../../_models/jobs/job";
import {getBaseFilter} from "../../services/api/filter_utils";
import {moment, TimezoneSelectorService} from "../../services/timezone-selector.service";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";

@Injectable({
    providedIn: 'root'
})
export class JobDataService implements OnDestroy {
    private readonly onDestroy = new Subject<void>();

    constructor(private dataService: GenericDataService,
                private dateInst: DateTimeInstanceService,
                private timezoneSelectorService: TimezoneSelectorService,
    ) {
    }

    getJobsFilter(createdOn?: Date, changedOn?: Date, status?: string, scopeType?: string) {
        return (createdOn ? this.dateQuery(createdOn, 'created_on') : this.createdOnDateFilter())
            .concat(scopeType ? [getBaseFilter(scopeType, 'type', 'eq')] : [])
            .concat(status ? [getBaseFilter(status.toUpperCase(), 'status', 'eq')] : [])
            .concat(this.dateQuery(changedOn, 'changed_on'))
    }

    createdOnDateFilter(): any {
        const start = this.dateInst.dtp.start;
        const end = this.dateInst.dtp.end;
        return [{
            and: [
                {name: 'created_on', op: 'ge', val: start},
                {name: 'created_on', op: 'le', val: end}
            ]
        }];
    }

    dateQuery(date: Date, attribute: string): any[] {
        if (!date) return [];

        const timezone = this.timezoneSelectorService.active_timezone;
        const start = moment.tz(date, timezone).startOf('day');
        const end = moment.tz(date, timezone).startOf('day').add(24, 'hours');
        return [{
            and: [
                getBaseFilter(start.toISOString(), attribute, 'ge'),
                getBaseFilter(end.toISOString(), attribute, 'le')
            ]
        }]
    }

    getJob(id: ModelID): Observable<SingleResponse<GenericJob>> {
        return this.dataService.getModelById('job', id)
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }
}
